import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Styles
import { Autocomplete, TextField, Chip, IconButton, CircularProgress } from '@mui/material';

// Icons
import CancelIcon from '@mui/icons-material/Cancel';

// Services
import { getUserInfo } from 'js/library/utils/helpers';
import { getSeuClubList } from 'js/library/utils/API/seuClube';

export default function PartnerChip({ setForm, origin }) {
  // clubeId
  const { id } = useParams();
  const uId = getUserInfo().uId;

  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const [selectedPartners, setSelectedPartners] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      const list = await getSeuClubList(uId);
      const formattedList = list.map((item) => ({
        label: `ClubeId: ${item.clubeId} | PartnerId: ${item.partnerId}`,
        partnerId: item.partnerId,
        clubeId: item.clubeId,
      }));

      setOptions(formattedList);

      // para definir o valor inicial com base no origin
      let fixedItem;
      if (origin === 'establishment') {
        fixedItem = formattedList.find((item) => item.clubeId === 'triibo');
      } else {
        fixedItem = formattedList.find((item) => item.clubeId === id);
      }

      if (fixedItem) {
        setSelectedPartners([fixedItem]);
        setForm((prevForm) => ({
          ...prevForm,
          partnerIdList: [fixedItem.partnerId],
        }));
      }

      setLoading(false);
    };

    fetchData();
  }, [uId, id, setForm, origin]);

  const handleChange = (event, newValue) => {
    let fixedItem;
    if (origin === 'establishment') {
      fixedItem = options.find((item) => item.clubeId === 'triibo');
    } else {
      fixedItem = options.find((item) => item.clubeId === id);
    }

    // para que o item fixo sempre permaneça selecionado
    const filteredValues = newValue.filter((item) => item.partnerId !== fixedItem?.partnerId);
    const updatedValues = fixedItem ? [fixedItem, ...filteredValues] : filteredValues;

    setSelectedPartners(updatedValues);

    const partnerIdList = updatedValues.map((item) => item.partnerId);
    setForm((prevForm) => ({
      ...prevForm,
      partnerIdList: partnerIdList,
    }));
  };

  return (
    <>
      {loading ? (
        <CircularProgress size={30} />
      ) : (
        <Autocomplete
          multiple
          options={options}
          getOptionLabel={(option) => option.label}
          value={selectedPartners}
          onChange={handleChange}
          renderTags={(selected, getTagProps) =>
            selected.map((option, index) => {
              const tagProps = getTagProps({ index });

              // verifica se o item é fixo (não pode ser removido)
              const isFixed =
                (origin === 'establishment' && option.clubeId === 'triibo') ||
                (origin === 'club' && option.clubeId === id);

              return (
                <Chip
                  key={option.partnerId}
                  label={option.label}
                  {...(isFixed ? {} : tagProps)} // aplica tagProps apenas se não for fixo
                  style={{
                    color: '#fff',
                    backgroundColor: isFixed ? '#818383' : '#CDA8E0',
                    margin: '4px',
                  }}
                  deleteIcon={
                    isFixed ? null : ( // remove o ícone de exclusão para o item fixo
                      <IconButton onMouseDown={(event) => event.stopPropagation()} size="small">
                        <CancelIcon fontSize="small" />
                      </IconButton>
                    )
                  }
                />
              );
            })
          }
          renderInput={(params) => <TextField {...params} label="Lista de partnerId" />}
        />
      )}
    </>
  );
}
